import React from 'react';
import { formatBytes } from '../../../Utils/GlobalUtils';
import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import { buildArtifactSizeLimit } from '../../../Constants/Files';
import { isNil } from 'lodash';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
	artifactSizeWarning: {
		color: 'red',
	},
	sizeInfo: {
		display: 'flex',
	},
}));
const Size = ({ size }) => {
	return (
		<Typography variant="body1">
			<span style={{ fontWeight: 'bold' }}>Size: </span>
			{size}
		</Typography>
	);
};
// Component to render size info for artifact files.
export const ArtifactSizeInfo = ({ bytes }) => {
	const classes = useStyles();
	let size = '';
	let isArtifactOverSized = false;
	if (!isNil(bytes)) {
		size = formatBytes(bytes);
		if (bytes > buildArtifactSizeLimit) {
			isArtifactOverSized = true;
		}
	}
	// show a warning when the build artifact size is more than 5MB.
	// Error message is displayed as a tooltip for warning Icon.
	if (isArtifactOverSized) {
		return (
			<Typography className={classes.sizeInfo} align="center">
				<Size size={size} />
				<Tooltip title={` WARNING! Artifact is larger than 5 MB`} arrow={true} placement="top">
					<Typography>
						<WarningIcon color="error" />
					</Typography>
				</Tooltip>
			</Typography>
		);
	}
	return <Size size={size} />;
};
